<template>

        <div class="financeApplication__form">
<!--            <ValidationProvider name="postcode"-->
<!--                                :rules="validationRules"-->
<!--                                v-slot="{ validate, errors }"-->
<!--                                slim-->
<!--            >-->
<!--                <div :class="classNames">-->
<!--                    <FinanceApplicationRow-->
<!--                        id="postcode"-->
<!--                        label="Postcode"-->
<!--                        :error-message="errors[0]"-->
<!--                    >-->
<!--                        <FinanceApplicationText-->
<!--                            id="postcode"-->
<!--                            placeholder="Enter Postcode"-->
<!--                            v-model="address.postcode"-->
<!--                            @input="onChange($event, validate)"-->
<!--                        />-->
<!--                    </FinanceApplicationRow>-->
<!--                </div>-->
<!--            </ValidationProvider>-->

            <div class="financeApplication__form__fields" v-if="!isManualAddressFormVisible">
                <FinanceApplicationAddressLookup
                    :initial-postcode="address.postcode"
                    @address-suggestion="onAddressSuggestion"
                    @show-manual-address-form="onManualAddressForm"
                />
            </div>

            <form class="financeApplication__manualAddressForm" v-else>
                <ValidationObserver ref="observer">
                    <div :class="manualFormClassNames">
                        <ValidationProvider name="address line 1"
                                            :rules="validationRules"
                                            v-slot="{ errors }"
                                            slim
                        >
                            <FinanceApplicationRow :error-message="errors[0]" id="addressLine1" label="Address Line 1">
                                <FinanceApplicationText
                                    id="addressLine1"
                                    placeholder="Address line 1"
                                    v-model="address.addressLine1"
                                >
                                </FinanceApplicationText>
                            </FinanceApplicationRow>
                        </ValidationProvider>

                        <FinanceApplicationRow id="addressLine2" label="Address Line 2">
                            <FinanceApplicationText
                                id="addressLine2"
                                placeholder="Address line 2"
                                v-model="address.addressLine2"
                            >
                            </FinanceApplicationText>
                        </FinanceApplicationRow>

                        <ValidationProvider name="town/city"
                                            :rules="validationRules"
                                            v-slot="{ errors }"
                                            slim
                        >
                            <FinanceApplicationRow :error-message="errors[0]" id="townCity" label="Town/city">
                                <FinanceApplicationText
                                    id="townCity"
                                    placeholder="Town/city"
                                    v-model="address.city"
                                >
                                </FinanceApplicationText>
                            </FinanceApplicationRow>
                        </ValidationProvider>

                        <ValidationProvider name="postcode"
                                            :rules="validationRules"
                                            v-slot="{ errors }"
                                            slim
                        >
                            <FinanceApplicationRow :error-message="errors[0]" id="postcode" label="Postcode">
                                <FinanceApplicationText
                                    id="postcode"
                                    placeholder="Postcode"
                                    v-model="address.postcode"
                                >
                                </FinanceApplicationText>
                            </FinanceApplicationRow>
                        </ValidationProvider>
                    </div>
                </ValidationObserver>


                <button type="button" class="financeApplication__addressSelector__manualAddress" @click="onManualAddressForm">Go back to search by postcode</button>
            </form>

        </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import FinanceApplicationText from './FinanceApplicationText.vue'
import FinanceApplicationRow from './FinanceApplicationRow.vue'
import FinanceApplicationAddressLookup from "./FinanceApplicationAddressLookup.vue";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        FinanceApplicationRow,
        FinanceApplicationText,
        FinanceApplicationAddressLookup
    },
    props: {
        initialValues: {
            type: Object,
            default: () => {}
        },
        windowWidth: {
            type: Number
        }
    },
    data() {
        return {
            address: this.initialValues.address,
            isManualAddressFormVisible: this.initialValues.address.isManualAddressFormVisible ? this.initialValues.address.isManualAddressFormVisible : false
        }
    },
    methods: {
        async onChange() {
            this.$emit('change-address', {
                key: this.initialValues.index,
                value: this.address
            })

            const valid = await this.$refs.observer.validate()
            this.$emit('validate', { key: `addressPostcode${this.initialValues.index}`, valid })
        },
        onAddressSuggestion({ address, postcode }) {
            this.address.addressLine1 = address.line_1
            this.address.addressLine2 = address.line_2
            this.address.city = address.city
            this.address.postcode = postcode

            this.$emit('change-address', {
                key: this.initialValues.index,
                value: this.address
            })

            this.$emit('validate', { key: `addressPostcode${this.initialValues.index}`, valid: true })
        },
        onManualAddressForm() {
            this.isManualAddressFormVisible = !this.isManualAddressFormVisible

            this.address.isManualAddressFormVisible = this.isManualAddressFormVisible

            if (this.isManualAddressFormVisible) {
                this.address.addressLine1 = ''
                this.address.addressLine2 = ''
                this.address.city = ''
                this.$emit('validate', { key: `addressPostcode${this.initialValues.index}`, valid: false })
            }
        }
    },
    computed: {
        classNames() {
            const className = 'financeApplication__form__fields'

            if (this.windowWidth > 670) {
                return `${className} ${className}--twoWide`
            }

            return `${className} ${className}--oneWide`
        },
        manualFormClassNames() {
            const className = 'financeApplication__form__fields'

            if (this.windowWidth > 670) {
                return `${className} ${className}--twoWide`
            }

            return `${className} ${className}--oneWide`
        },
        validationRules() {
            return {
                required: true,
            }
        },
    },
    watch: {
        address: {
            handler(val) {
                if (this.isManualAddressFormVisible && (val.addressLine1 !== '' || val.addressLine2 !== '' || val.city !== '')) {
                    this.onChange()
                }
            },
            deep: true
        },

    }
}
</script>